export var ConsumerInfoFields = {
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    EMAIL_ADDRESS: "emailAddress",
    MOBILE_NUMBER: "mobileNumber",
    COUNTRY_CODE: "countryCode",
};
